export type CollectionScope = 'tenant' | 'global';

/**
 * Toute collection absente de cette liste est traitée comme 'tenant'
 * (comportement actuel, inchangé). Le pattern temps réel (RequestService +
 * WebSocketService) suppose par défaut qu'une collection appartient à la
 * base du projet actif. 'global' déroge à cette règle pour les collections
 * qui n'ont pas de notion de projet actif (ex: Project lui-même — la liste
 * des projets d'un utilisateur reste valable quel que soit le projet ouvert).
 *
 * Dashboard/Chart vivent physiquement dans la base centrale (GLOBAL_ROOM),
 * mais restent logiquement liés à un ou plusieurs projets : ils ne doivent
 * PAS être 'global' ici, sous peine de partager un seul cache localStorage
 * (et un seul point d'entrée temps réel) entre tous les projets, ce qui a
 * causé la fuite de données inter-projets corrigée en UF-2595. Leur room
 * socket réelle est déjà résolue côté API par projet (io/collectionScope.js).
 */
export const COLLECTION_SCOPE: Record<string, CollectionScope> = {
  Project: 'global',
  TrackerConfig: 'global',
};

export const GLOBAL_ROOM = 'cad42Users';

export function scopeOf(collection: string): CollectionScope {
  return COLLECTION_SCOPE[collection] ?? 'tenant';
}

/**
 * Base de la clé de cache/room pour une collection : la room globale fixe
 * pour 'global', la base/room du projet actif (`currentDb`) sinon. Point
 * d'entrée unique — RequestService et WebSocketService partagent cette même
 * règle au lieu de la réimplémenter chacun de leur côté.
 */
export function dbScopeFor(collection: string, currentDb: string): string {
  return scopeOf(collection) === 'global' ? GLOBAL_ROOM : currentDb;
}
